import b from "./utils/hexToHsla";
import c from "./utils/rgbToHsl";
import d from "./utils/roundTo4Dp";
export default (function (e) {
  if (e.indexOf("#") + 1) return b(e);
  var f = e.trim().replace(/\s*/g, "").match(/(rgba?|hsla?)\((.*)\)/i);
  if (!f) return !1;
  var g = f[2].split(",").map(parseFloat),
      h = g[0],
      i = g[1],
      j = g[2],
      k = g[3] || 1;

  if (f[1].indexOf("rgb") + 1) {
    var a = c(h, i, j);
    return {
      h: a[0],
      s: a[1],
      l: a[2],
      a: k
    };
  }

  return {
    h: d(h / 360),
    s: i / 100,
    l: j / 100,
    a: k
  };
});